import { Component, inject } from '@angular/core';
import { SharedService } from '@shared/services/shared.service';
import { HospitalLicenseService } from 'app/services/license/hospital/hospital-license.service';

@Component({
  selector: 'app-hospital-management',
  templateUrl: './hospital-management.component.html',
  styleUrls: ['./hospital-management.component.scss']
})
export class HospitalManagementComponent {
  public referenceTypes: string[] = ['Hospital Attestation', 'SICF Attestation'];
  public hospitalReference: string = 'HospitalReference';

  public licenseService = inject(HospitalLicenseService);
  public sharedService = inject(SharedService);

  uploadData(event: Event, isSicf: boolean): void {
    const files = (event.target as HTMLInputElement).files;
    if (!files || files.length === 0) {
      return;
    }
    let file = files[0];
    const formData = new FormData();
    formData.append("csv", file, file.name);

    this.licenseService.uploadHospitalData(formData, isSicf).subscribe({
      complete: () => {
        this.sharedService.toastr.success("Data uploaded successfully");
        (event.target as HTMLInputElement).value = '';
      },
      error: e => {
        (event.target as HTMLInputElement).value = '';
        this.sharedService.toastr.error("Could not upload document");
        console.log('Error uploading document', e);
      }
    });
  }
}
